import SuggestedTimes from 'components/form/SuggestedTimes/styled';

export default SuggestedTimes;
